import React,{useRef, useState, useEffect, useContext} from "react";
import {X, CircleNotch, Info, Eye} from "@phosphor-icons/react";
import layerEvents from "../utils/layerEvents";
import atlasApi from "../utils/atlasapi";
import { Col, Row, Modal, Button} from "react-bootstrap";
import EditableRange from "../components/EditableRange";
import globalContext						from "../utils/globalContext";




const scale = [
	{
		color: "#265100",
		opacity: .25,
		label: "35 - 40 dB"
	},
	{
		color: "#265100",
		opacity: .5,
		label: "40 - 45 dB"
	},
	{
		color: "#265100",
		opacity: .75,
		label: "45 - 50 dB"
	}
];

const paintOpacity = (s) => {
	return {
		'fill-opacity': ['case',
			['<', ['get', 'decibel'], 40], s[0].opacity,
			['all', ['>=', ['get', 'decibel'], 40],['<', ['get', 'decibel'], 45]], s[1].opacity,
			['>=', ['get', 'decibel'], 45], s[2].opacity,

			1
		]
	};
};

const layerPaint = {
	...{
		'fill-color': ['case',
			['<', ['get', 'decibel'], 40], scale[0].color,
			['all', ['>=', ['get', 'decibel'], 40],['<', ['get', 'decibel'], 45]], scale[1].color,
			['>=', ['get', 'decibel'], 45], scale[2].color,

			'#265100'
		]
	},
	...paintOpacity(scale)
};


export default function OverlayNoise({onClose}){


	const layerId = 'noise-fill';
	const sourceId = 'noise-source';

	const [noiseData, setNoiseData]		= useState(null);
	const [opacity, setOpacity]			= useState(100);
	const [hiddenBands, setHiddenBands]	= useState(new Set());

	const context						= useContext(globalContext);
	const tc							= context.tc;
	const map							= tc.map;




	useEffect(() => {
		getNoiseLayer();
		tc.sensorModeForce();
		tc.updatePanelLayer = getNoiseLayer;
		return ()=>{
			remLayer();
			delete tc.updatePanelLayer;
		}
	}, []);


	const handleOpacityChange = (opc) => {
		setOpacity(opc);
		setLayerOpacity(layerId, opc/100);
	}

	const handleToggleBand = (index) => {
		const next = new Set(hiddenBands);
		if (next.has(index)) next.delete(index);
		else next.add(index);
		setHiddenBands(next);

		if (map.getLayer(layerId)) {
			const newScale = scale.map((s, i) => ({
				...s,
				opacity: next.has(i) ? 0 : s.opacity * (opacity / 100)
			}));
			const op = paintOpacity(newScale);
			map.setPaintProperty(layerId, 'fill-opacity', op['fill-opacity']);
		}
	}

	const addLayer = (data) => {
		if(!data?.isolines)
			return;

		if(!map.getSource(sourceId)){
			map.addSource(sourceId, {
				type: 'geojson',
				data: data.isolines
			});

			map.addLayer({
				id: layerId,
				type: 'fill',
				source: sourceId,
				paint: layerPaint
			});

			map.moveLayer(layerId);

		}

	}
	const remLayer = () => {

		if(!map.getSource(sourceId))
			return;


		if(map.getLayer(layerId))
			map.removeLayer(layerId);

		if(map.getSource(sourceId))
			map.removeSource(sourceId);


	}
	const getNoiseLayer = () => {

		atlasApi.getNoiseLayer(context.tc.scenario.projectid, context.tc.scenario.scenario_id).then((result)=>{
			addLayer(result);
			setNoiseData(result);
		});

	}
	const setLayerOpacity = (l, opacity) => {
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = map.getLayer(l);
			if(!layer)
				return;

			if (layer.type === 'symbol')  {
				map.setPaintProperty(l, 'icon-opacity', opc);
				map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				const newScale = scale.map((s, i) => ({
					...s,
					opacity: hiddenBands.has(i) ? 0 : s.opacity * opacity
				}));
				var op = paintOpacity(newScale);
				map.setPaintProperty(l, layer.type+'-opacity', op[layer.type+'-opacity']);
			}
		}
	}

	const getTurbineType = () => {
		const type = tc.scenario.turbine_types.find((t)=>{return tc.scenario.wtgSettings.turbineType == t.turbine_type});
		return type.turbine_name ?? '';
	}

	const handleCalculate = () => {


		const requests = [
			atlasApi.startNoiseLayer(tc.scenario.projectid, tc.scenario.scenario_id),
			atlasApi.startShadowLayer(tc.scenario.projectid, tc.scenario.scenario_id)
		];

		return Promise.all(requests).then((res)=>{
			setNoiseData({"method":"","state":"waiting"});
			context.QN.current.show("Noise and Shadow calculation in progress.");
			
			
			if(tc.handler.type == "sensors"){
				tc.handler.handleCalcRequestDone();
			}
			
			
		});
	}


	return (
		<>
		{!!noiseData?.state &&
			<div className="card overlayNoise">
				<div className="row title">
					Noise levels
					<span onClick={onClose} className="btn btn-close alt float-end"><X size={12} weight="bold" /></span>
				</div>
				{
				(noiseData.state == 'in_progress' || noiseData.state == 'waiting') &&
					<div className="my-3 mx-1">Noise calculation in progress. This will take a few minutes.</div>
				}
				{
				noiseData.state == 'finished' &&
				<>
					<div className="my-3">
						Decibel scale (dB)

						{!!noiseData && noiseData.method != 'NORD2000' &&
						<div className="branded-tooltip">
							<Info weight="bold" size={16} />
							<div className="text">
								<span><Info weight="bold" size={16} /> DECIBEL </span>

								Is a simplified noise calculation method in windPRO. It uses the ISO 9613-2 standard with basic sound propagation modelling. It provides conservative noise predictions for regulatory compliance and initial assessments. The calculation assumes the turbine is always operating and oriented directly downwind towards the receptor.
							</div>
						</div>
						}
						{!!noiseData && noiseData.method == 'NORD2000' &&
						<div className="branded-tooltip">
							<Info weight="bold" size={16} />
							<div className="text">
								<span><Info weight="bold" size={16} /> NORD2000 </span>

								NORD2000 is a module in windPRO that represents a more advanced and detailed approach to noise calculations. It incorporates complex modelling of sound propagation that accounts for varying meteorological conditions such as wind direction, atmospheric stability, temperature gradients, and terrain features.
								<br /><br />
								This allows NORD2000 to simulate how noise levels fluctuate over time and under different weather scenarios, making it more precise for environments where sound propagation is heavily influenced by local climatic factors. The method is especially valuable for statistical analyses, as it can predict not just worst-case levels but how frequently certain noise levels might occur
							</div>
						</div>
						}

					</div>
					<div className="scale">
						<span className="hide-all-link" onClick={()=>{
							const allHidden = hiddenBands.size === scale.length;
							const next = new Set();
							if (!allHidden) scale.forEach((_, i) => next.add(i));
							setHiddenBands(next);
							if (map.getLayer(layerId)) {
								const newScale = scale.map((s, i) => ({
									...s,
									opacity: next.has(i) ? 0 : s.opacity * (opacity / 100)
								}));
								map.setPaintProperty(layerId, 'fill-opacity', paintOpacity(newScale)['fill-opacity']);
							}
						}}>
							{hiddenBands.size === scale.length ? 'Show all' : 'Hide all'}
						</span>
						<ul>
							{
								scale.map((a, i)=>{
									const hidden = hiddenBands.has(i);
									return (
										<li key={i}>
											<span className="square" style={{backgroundColor:a.color, opacity: hidden ? 0.2 : a.opacity}}></span>
											{a.label}
											<span onClick={()=>handleToggleBand(i)} className={"band-eye"+(hidden ? " opacity-25" : "")}>
												<Eye size={16} weight="bold" />
											</span>
										</li>
									)
								})
							}
						</ul>
					</div>
					<Row>
						<Col xs="12 style-name pt-2">
							<b>Layer opacity (%)</b>
						</Col>
						<Col xs="12">
							<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={opacity} defaultValue={100} onChange={(e)=>{handleOpacityChange(e.target.value);}} />
						</Col>
						<Col xs="12 mt-2">
							<b>Turbine type used: </b>
						</Col>
						<Col xs="12 mt-2 mb-4">
							{getTurbineType()}
						</Col>
					</Row>
				</>
				}
			</div>
		}
		{!!noiseData && !noiseData.state &&
			<Modal className="modalNoise" show={true} onHide={onClose}  centered>
				<Modal.Header closeButton>
					<Modal.Title>Calculate noise levels</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Row className="mb-3">
						<Col xs="12" className="feedback-text mb-5">
							Noise levels are not calculated for this scenario yet. This prosess takes a few minutes.
						</Col>
					</Row>
				</Modal.Body>

				<Modal.Footer>
					<Button variant="outline-primary" onClick={onClose}>Cancel</Button>
					<Button variant="primary" type="submit" onClick={handleCalculate}>Start calculation to continue</Button>
				</Modal.Footer>
			</Modal>
		}
		</>

	)
}
